import { useState } from "react";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import * as API from "../api";

// Same rounded-full pill button family as screens/User/Booking.js's OrderCard
// actions (see its primary/secondary buttons ~line 258-272). `size="lg"` is
// the bigger standalone-CTA variant used by thankyou.js; the default matches
// the compact inline row-action size used in the account bookings list.
const SIZE_CLASSES = {
    default: "gap-1.5 px-3.5 py-2 text-xs",
    lg: "gap-2 px-6 py-3 text-sm",
};

const PaymentContainer = ({buttonText = "", style = {}, reservation = null, disabled = false, size = "default"}) => {
    const order = reservation || JSON.parse(localStorage.getItem("order_response")) || {};

    const [preparingPayment, setPreparingPayment] = useState(false);


    function submitToPaywall(payload, signature, paywallUrl) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = paywallUrl;
        form.target = '_self';

        const payloadInput = document.createElement('input');
        payloadInput.type = 'hidden';
        payloadInput.name = 'payload';
        payloadInput.value = payload;

        const signatureInput = document.createElement('input');
        signatureInput.type = 'hidden';
        signatureInput.name = 'signature';
        signatureInput.value = signature;

        form.appendChild(payloadInput);
        form.appendChild(signatureInput);

        document.body.appendChild(form);

        form.submit();

        // Optional: Remove form after submission
        document.body.removeChild(form);
    }
    // handle payment
    const preparePayment = () => {
        if (!order.id) return;
        setPreparingPayment(true);
        API.preparePayment(order.id)
            .then((res) => {
                submitToPaywall(res?.data?.json_payload, res?.data?.signature, res?.data?.paywallUrl);
            })
            .catch((err) => {
                console.log("this is error", err);
            })
            .then(() => {
                setPreparingPayment(false);
            });
    }

    const sizeClasses = SIZE_CLASSES[size] || SIZE_CLASSES.default;

    return(
        <button
            type="button"
            onClick={preparePayment}
            disabled={preparingPayment || disabled}
            style={style}
            className={`inline-flex items-center rounded-full bg-accent-500 font-semibold text-brand-900 shadow-card transition-colors hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-accent-500 ${sizeClasses}`}
        >
            {preparingPayment ? (
                <>
                    <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden>
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4Z" />
                    </svg>
                    <span>{buttonText}</span>
                </>
            ) : (
                <>
                    <CreditCardIcon className="h-4 w-4 animate-bounce" />
                    <span>{buttonText}</span>
                </>
            )}
        </button>
    )

};

export default PaymentContainer;